<template lang="pug">
  .accordionList(@click="(e) => $emit('click', e)")
    slot
</template>
<script>
import $ from 'jquery'
import _ from 'lodash'

export default {
  props: {
    container: {
      type: String,
      default: 'body'
    },
    thresold: {
      type: Number,
      default: 0
    },
    sortBy: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      jqueryContainer: $(this.container),
      isAjusting: false,
      lastOpenItem: null
    }
  },
  mounted () {
    let rafTimer = null
    this.jqueryContainer.scroll(() => {
      cancelAnimationFrame(rafTimer)
      rafTimer = requestAnimationFrame(() => {
        this.adjustFixedElements()
      })
    })
    $(window).on('resize', () => this.jqueryContainer.trigger('scroll'))
    this.jqueryContainer.trigger('scroll')
  },
  methods: {
    selectNextItem () {
      let $children = _.sortBy(_.filter(this.$children, (c) => $(c.$el).hasClass('accordionList-item')), this.sortBy)
      let index = -1
      if (!this.lastOpenItem) {
        index = _.findIndex($children, (c) => $(c.$el).offset().top > 60)
      } else {
        if (this.lastOpenItem) {
          index = $children.indexOf(this.getActiveChildren())
        }
        index++
        while (index < $children.length && typeof $children[index].accordionItem === 'undefined') {
          index++
        }
      }
      if (index < $children.length) {
        this.setLastSelectedItem($children[index].accordionItem)
        this.assureItemIsVisible($children[index].accordionItem)
      }
    },
    selectPreviousItem () {
      let $children = _.sortBy(this.$children, this.sortBy)
      let index = 0
      if (this.lastOpenItem) {
        index = $children.indexOf(this.getActiveChildren())
        if (index === -1) {
          // select first item
          return this.selectNextItem()
        }
      } else {
        return this.selectNextItem()
      }
      index--
      while (index >= 0 && typeof $children[index].accordionItem === 'undefined') {
        index--
      }
      if (index >= 0) {
        this.setLastSelectedItem($children[index].accordionItem)
        this.assureItemIsVisible($children[index].accordionItem)
      }
    },
    toggleActiveItem () {
      if (this.lastOpenItem) {
        $('.header', this.lastOpenItem.$el).click()
        // this.lastOpenItem.toggleActive()
      }
    },
    getActiveChildren () {
      if (this.lastOpenItem) {
        if (this.lastOpenItem.$parent === this) {
          return this.lastOpenItem
        } else {
          return this.lastOpenItem.$parent
        }
      }
      return null
    },
    setLastSelectedItem (item) {
      this.lastOpenItem = item
    },
    getLastSelectedItem () {
      return this.lastOpenItem
    },
    appendInfo ($el, info) {
      if ($el.children('.info').length === 0) {
        $el.append('<pre class="info"></pre>')
      }
      $el.children('.info').html(JSON.stringify(info))
    },
    updateLayout () {
      this.$nextTick(() => this.adjustFixedElements())
    },
    assureItemIsVisible (item) {
      let $item = $(item.$el)
      let marginTop = item.active ? 25 : 110
      let $parent = this.jqueryContainer
      // let wScrollTop = $parent.scrollTop()
      $parent.stop() // cancel previous animation, if any
      // timeout to wait toggleActive animation of an other item...
      setTimeout(() => {
        $parent.stop() // cancel previous animation, if any
        let wHeight = $parent.height()
        let offsetTop = $item.offset().top
        if (offsetTop < marginTop) {
          $parent.animate({ scrollTop: $item.position().top - marginTop }, 500)
        } else if (wHeight - 300 < offsetTop) {
          $parent.animate({ scrollTop: $item.position().top - wHeight + 300 }, 500)
        }
        setTimeout(() => {
          this.adjustFixedElements()
        }, 600)
      }, 100)
    },
    adjustFixedElements () {
      if (!($(window).width() < 500 || $(window).height() < 500)) {
        let actives = this.$el.getElementsByClassName('accordionList-item active')
        var that = this
        let wHeight = that.jqueryContainer.height()
        for (let i = 0; i < actives.length; i++) {
          let active = actives[i]
          var marginTop, offset, $active
          $active = $(active)
          let activeOffsetTop = $active.offset().top
          let activeHeight = $active.height()
          marginTop = wHeight > 500 ? that.thresold : 0
          let $header = $active.children('.header')
          if (activeOffsetTop < marginTop && marginTop < activeOffsetTop + activeHeight) {
            if (!$active.hasClass('fixedHeader')) {
              $active.addClass('fixedHeader')
            }
            $header.width($active.width() - 20)
            if (marginTop > activeOffsetTop + activeHeight - 60) {
              offset = activeOffsetTop + activeHeight - 60 - marginTop
              $header.css('margin-top', offset)
            } else {
              $header.css('margin-top', 0)
            }
          } else {
            if ($active.hasClass('fixedHeader')) {
              $active.removeClass('fixedHeader')
            }
            $header.width('auto').css('margin-top', 0)
          }
          let $footer = $active.find('> .accordionList-body > .footer')
          if (wHeight - 100 > activeOffsetTop && wHeight < activeOffsetTop + activeHeight) {
            if (!$active.hasClass('fixedFooter')) {
              $active.addClass('fixedFooter')
            }
            $footer.width($active.width())
          } else {
            if ($active.hasClass('fixedFooter')) {
              $active.removeClass('fixedFooter')
            }
            $footer.width('100%')
          }
        }
        let stayTopFixedElements = this.$el.getElementsByClassName('stayTopFixed')
        let lastBefore = {}
        let firstAfter = {}
        for (let i = 0; i < stayTopFixedElements.length; i++) {
          let stayTopFixed = stayTopFixedElements[i]
          let $stayTopFixed = $(stayTopFixed)
          if ($(stayTopFixed).hasClass('fixedHeader')) {
            return
          }
          let group = $stayTopFixed.data('group')
          if (lastBefore[group] == null) {
            lastBefore[group] = void 0
          }
          if ($stayTopFixed.parent().offset().top < this.thresold / 2) {
            lastBefore[group] = $stayTopFixed
          } else {
            if (firstAfter[group] === void 0) {
              firstAfter[group] = $stayTopFixed
            }
          }
        }
        let $parent = that.jqueryContainer
        let wScrollTop = $parent[0].scrollTop
        for (let k in lastBefore) {
          let v = lastBefore[k]
          if (v == null || v === undefined) {
            $('.stayTopFixed.fixed[data-group=' + k + ']', this.$el).removeClass('fixed')
            continue
          }
          $('.stayTopFixed.fixed[data-group=' + k + ']', this.$el).not(v).removeClass('fixed')
          if ((firstAfter[k] != null) && firstAfter[k].position().top < wScrollTop + v.height() + this.thresold + (firstAfter[k].data('delta') || 0)) {
            v.css({
              'margin-top': firstAfter[k].position().top - wScrollTop - v.height() - this.thresold
            })
          } else {
            if (v.css('margin-top') !== '0px') {
              v.css({
                'margin-top': 0
              })
            }
          }
          v.addClass('fixed')
        }
      }
      this.$children.forEach((child) => {
        if (child.isLoadingHeader) {
          if (child.isAlmostVisible(this.jqueryContainer)) {
            child.load()
          }
        }
      })
    }
  },
  watch: {
    lastOpenItem (newValue, lastValue) {
      if (lastValue) {
        lastValue.beNotTheLastSelected()
      }
      newValue.beTheLastSelected()
    }
  }
}
</script>



// WEBPACK FOOTER //
// Accordion.vue?d74e82bc